/*
* Gobal state management for Vue code.
* 
* Please read before making edits in this file:
* https://vuex.vuejs.org/en/core-concepts.html
* 
*/

import Vue from "vue";
import Vuex from "vuex";
// import eventHub from "./event-hub";
// import { wpApi, mgApi } from "./api";

Vue.use(Vuex);

// vuex modules
// import categories from "./vuex-modules/categories";
// import mediaCenter from "./vuex-modules/media-center";
import agenda from "./vuex-modules/agenda";

export default new Vuex.Store({
    modules: { agenda },
    state: {},
    getters: {},
    mutations: {},
    actions: {}
});



// WEBPACK FOOTER //
// ./src/js/store.js